import { Badge, Box, Checkbox } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { TodoStatus } from '.';

interface TodoStatusToggleProps {
  status: TodoStatus;
  onStatusChange(newStatus: TodoStatus): void;
  canTransition: boolean;
}

export const TodoStatusToggle: React.FC<TodoStatusToggleProps> = ({
  status,
  onStatusChange,
  canTransition,
}) => {
  return (
    <Checkbox
      onChange={(event) =>
        onStatusChange(event.target.checked ? 'CHECKED' : 'UNCHECKED')
      }
      colorScheme="green"
      isChecked={status === 'CHECKED'}
      isDisabled={status === 'DISMISSED' || !canTransition}
      size="lg"
      aria-label={status === 'UNCHECKED' ? t`Check` : t`Uncheck`}
    >
      {status === 'DISMISSED' && (
        <Box ml={2}>
          <Badge>{t`Abandoned`}</Badge>
        </Box>
      )}
    </Checkbox>
  );
};
